import { FC } from 'react';
import { Close, Input, InputWrapper } from './styles';
import { CloseIconButton } from '../buttons/iconButtons/closeButton';

interface InputSearchProps {
    onChange: (searchValue: string) => void;
    value: string;
}

export const ContoledInputSearch: FC<InputSearchProps> = ({
    onChange,
    value,
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    const handleClear = () => {
        onChange('');
    };

    return (
        <InputWrapper $hide={false}>
            <Input
                role="input-search"
                value={value}
                onChange={handleChange}
                autoComplete="off"
                $hide={false}
            />
            {value && (
                <Close>
                    <CloseIconButton onClick={handleClear} />
                </Close>
            )}
        </InputWrapper>
    );
};
